<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>{{heading}}
            <ng-container *ngFor="let action of actions">
                <mat-icon class="m-l-10 m-b-5" (click)="handleActionClick($event,action)" [matTooltip]="action.tooltip"
                    color="primary">{{action.icon}}</mat-icon>
            </ng-container>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-info">
        <ng-container *ngIf="listData; else listLoading">
            <ng-container *ngIf="listData.length; else noResults">
                <ng-container *ngFor="let group of listData">
                    <div class="list-header">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <mat-list-item *ngFor="let item of group.items" (click)="loadItem(item)" class="auto-height">
                            <div class="list-item">
                                <div class="list-item-details">
                                    <div matLine class="list-item-title">
                                        <div class="full-height">
                                            <div class="task-status-indicator" [ngClass]="item.status.toLowerCase()"
                                                [matTooltip]="'Task status is ' + item.status">
                                            </div>
                                        </div>
                                        <span>{{ item.task }}</span>
                                    </div>

                                    <div matLine class="list-item-footer">
                                        <div>Created By: {{ item.createdBy }} at {{ item.createdAt | date :
                                            'HH:mm'}}</div>
                                        <div>Assigned to: {{ assigneeSummary(item) }}</div>
                                        <div *ngIf="item.updatedAt > item.createdAt">
                                            Edited {{ item.updatedAt | dateDiff }} ago
                                        </div>
                                    </div>
                                </div>
                                <div class="view-icon">
                                    <mat-icon>edit</mat-icon>
                                </div>
                            </div>
                        </mat-list-item>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>